var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", { staticClass: "icon", attrs: { src: _vm.svgs[_vm.image] } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/SvgImage.vue